import { Injector } from '@angular/core';
import { FormArray, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { SettingsService, _HttpClient } from '@delon/theme';
import { CopyTransactionService } from '@shared-feature/components/actions/doc-edit-actions/copy-transaction/copy-transaction.service';
import { Observable } from 'rxjs';

import { StockBundleHelperService } from '../stock-bundle-helper.service';
import { DataBaseService } from './data-base.service';

export abstract class DocBaseService extends DataBaseService {
  activatedRoute;

  constructor(injector: Injector) {
    super(injector);
    this.activatedRoute = injector.get(ActivatedRoute);

    const router = injector.get(Router);
    router.events.subscribe((event: any) => {
      // On NavigationEnd
      if (event.type === 1) {
        const navigation = router.getCurrentNavigation();
        const state = navigation?.extras.state as any;

        if (state?.cloneData && state?.data) {
          this.eventData = { type: 'clone', data: state?.data };
        }

        if (state?.transferData) {
          this.eventData = { type: 'transfer', data: state?.data };
          this.triggerEvent({ type: state?.purpose, data: state?.data });
        }

        if (state?.sendOption) {
          const type = state?.isOnlinePayment
            ? 'onlinePayment'
            : 'sendTransaction';

          this.eventData = {
            type: type,
            option: state?.sendOption,
            data: state?.data
          };
        }

        this.checkCopyParams();
      }
    });
  }

  checkCopyParams() {
    const routeParams = this.activatedRoute.snapshot.queryParams;
    const copyService = this.injector.get(CopyTransactionService);
    if (!!routeParams['destination'] && !!routeParams['source'] && copyService.copyIsActivated()) {
      copyService.getCopyData(routeParams).subscribe({
        next: (res: any) => {
          this.eventData = { type: 'copy', data: res };
          this.triggerEvent({ type: 'copy', data: res });
          copyService.copyIsActivated.set(false);
        }
      });
    }
  }

  get cutoffDate() {
    const cd =
      this.injector.get(SettingsService).user['company']?.['cutoffDate'];
    return new Date(cd);
  }

  eventData: any | null = null;
  transactionType: number | null = null;

  abstract void(body: any): Promise<any>;

  abstract devoid(id: string): Observable<any>;

  abstract setBounced(body: any): Observable<any>;

  abstract clearChq(id: string): Observable<any>;

  abstract setPDC(): void;

  abstract setAndSavePDC(id: string): Observable<any>;

  abstract setAndSaveUnmarkPDC(id: string): Observable<any>;

  abstract recalcLine(line: FormGroup): void;

  abstract recalcHeader(header: FormGroup, lines: any[]): void;

  abstract transferToSo(id: string): void;

  abstract transferToDo(id: string): void;

  abstract transferToSinv(id: string): void;

  abstract transferToCs(id: string): void;

  abstract transferToCsr(id: string): void;

  abstract transferToPo(id: string): void;

  abstract transferToGrn(id: string): void;

  abstract transferToPinv(id: string): void;

  abstract transferToCp(id: string): void;

  abstract transferToCpf(id: string): void;

  abstract doDocTransfer(docType: string): Observable<any>;

  close(id: string): void {
    return;
  }

  reOpen(id: string): void {
    return;
  }

  triggerEvent(event: any) {
    this.eventTrigger.next(event);
  }

  override removeLine(formArray: FormArray, index: number) {
    const bundleHelper = this.injector.get(StockBundleHelperService);
    const removedBundle = bundleHelper.removeBundleGroup(formArray, index);
    if (!removedBundle) {
      super.removeLine(formArray, index);
    }
    this.recalcHeader(<FormGroup>formArray.parent, formArray.value);
  }

  formatAddress(res: any): string {
    let addrArr = [
      res.address1,
      res.address2,
      res.address3,
      res.address4
      //res.zipCode
    ];

    // Join all non-empty address lines with line break
    let fullAddress = addrArr
      .filter(function (val) {
        return val != null && val !== '';
      })
      .join('\r\n');

    // If full address does not contains zip code, append it in new line
    if (res.zipCode && !fullAddress.includes(res.zipCode)) {
      fullAddress += `\r\n${res.zipCode}`;
    }
    return fullAddress;
  }

  createMultiPaymentForm() {
    const form = this.fb.group({
      _rowId: [Date.now().toString(36) + Math.random().toString(36).slice(2), []],
      accountId: ['', []],
      account: [<any>null, [Validators.required]],
      description: ['', [Validators.maxLength(50)]],
      referenceNo: ['', [Validators.maxLength(50)]],
      amount: [0, [Validators.min(0.01)]],
      bankChargesAmount: [0, []],
      bankChargesAccountId: [<any>null, []],
      bankChargesAccount: [<any>null, []],
    });

    form.controls.account.valueChanges.subscribe(val => {
      form.controls.accountId.setValue(val?.id);
    });

    form.valueChanges.subscribe(() => {
      if (!this.observeChanges) return;
      this.modified = true;
    });
    return form;
  }
}
